import React, { Component } from 'react';
import PropTypes from 'prop-types';

class VxSimpleInputField extends Component {
	static propTypes = {
		input: PropTypes.object,
		label: PropTypes.string,
		meta: PropTypes.object,
		id: PropTypes.string,
		validateOnBlur: PropTypes.bool,
	}

	render() {
		const {
			input,
			label,
			meta: { touched, error, active },
			id,
			validateOnBlur
		} = this.props;

		let hasError = validateOnBlur ? !active && touched && error : touched && error;

		return (
			<div className={`vx_form-group ${hasError ? 'vx_has-error-with-message' : ''}`}>
				<label htmlFor="form-control-error">{label}</label>
				<input
					className="form-control vx_form-control"
					type="text"
					{...input}
					id={id}
				/>
				{
					hasError && <span className="vx_form-control-message" id="help-text">{error}</span>
				}
			</div>
		)
	}
}

export default VxSimpleInputField;



// WEBPACK FOOTER //
// ./buttons/components/vxFields/VxSimpleInputField.js